<!--
 * @Author: WGL
 * @Date: 2023-06-21 09:23:33
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2026-04-03 16:37:48
 * @Description: 
-->
<template>
  <div class="w pt10">
    <el-tooltip
      v-if="info?.code"
      :content="`${t('编码')}：${info?.code}`"
      effect="dark"
      :persistent="false"
      placement="top"
    >
      <div class="omit b">{{ info?.code }}</div>
    </el-tooltip>
    <el-tooltip
      v-if="hasOemCode"
      :content="`${t('OEM编码')}：${info?.oem_code}`"
      effect="dark"
      :persistent="false"
      placement="bottom"
    >
      <div class="g6">
        <div v-for="code in oemCode" :key="code" class="fxm">
          <div v-if="isAutoParts" class="fxmc">
            <span
              v-if="oemInfo"
              class="dl cp oem-code-info"
              :title="`${t('OEM信息')}`"
              @click="handleOemSearch(code)"
            >
              E
            </span>
            <jwt-icon
              v-if="googleSearch"
              class="c0 cp"
              icon="camera-lens-ai-line"
              size="16"
              :title="`${t('谷歌搜图')}`"
              @click="handleGoogleSearch(code)"
            />
          </div>
          <div class="ex omit">{{ code }}</div>
        </div>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
  // 基础产品编码组件
  import { defineComponent, reactive, toRefs, computed } from 'vue'
  import { t } from '@/utils/i18n'
  import { useStore } from 'vuex'
  import { hideOemCode } from '@/utils/specialCompany'
  export default defineComponent({
    name: 'BaseCode',
    components: {},
    props: {
      info: { type: Object, default: () => {} },
      googleSearch: { type: Boolean, default: false },
      oemInfo: { type: Boolean, default: true },
    },
    emits: ['code-search', 'oem-search'],
    setup(props, { emit }) {
      const state = reactive({
        gridData: [],
      })
      const store = useStore()
      const isAutoParts = computed(() => store.getters['sys/isAutoParts'])
      const oemCode = computed(() => {
        return props?.info?.oem_code?.split(',')
      })
      const hasOemCode = computed(() => {
        if (props?.info?.oem_code) {
          return hideOemCode()
        }
        return false
      })

      const handleGoogleSearch = (code) => {
        emit('code-search', code, { oem_code: props?.info?.oem_code })
      }
      const handleOemSearch = (code) => {
        emit('oem-search', code, { oem_code: props?.info?.oem_code })
      }
      return {
        oemCode,
        hasOemCode,
        isAutoParts,
        ...toRefs(state),
        t,
        handleGoogleSearch,
        handleOemSearch,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .oem-code-info {
    width: 15px;
    height: 15px;
    border-radius: 100%;
    font-size: 10px;
    color: #fff;
    line-height: 15px;
    text-align: center;
    margin-right: 4px;
    background-color: var(--el-color-primary);
  }
</style>
